import pathify from 'vuex-pathify'; // Pathify options

pathify.options.mapping = 'simple';
pathify.options.strict = process.env.DEV;
export default pathify;